module.exports = __webpack_public_path__ + "static/media/register2.31862f3c.jpg";